import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_CONFIG from './config/api';
import './AcessosUsuarios.css';

export default function AcessosUsuarios({ onToggleSidebar, onAtualizar, usuarioId, embedded = false }) {
  const [usuarios, setUsuarios] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [busca, setBusca] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState(false);
  const headers = () => ({ 'x-auth-token': localStorage.getItem('token') });
  useEffect(() => {
    let ativo = true;
    axios.get(`${API_CONFIG.API_URL}/acessos`, { headers: headers() }).then(({ data }) => {
      if (!ativo) return;
      setCatalogo(data.catalogo);
      setUsuarios(data.usuarios.map(u => ({ ...u, selecionados: u.menus_efetivos })));
    }).catch(err => { if (ativo) { setErro(true); setMensagem(err.response?.data?.message || 'Não foi possível carregar os acessos.'); } })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, []);
  const salvar = async (usuario, restaurar = false) => {
    if (!window.confirm(`${restaurar ? 'Restaurar os menus padrão' : 'Salvar os menus selecionados'} de ${usuario.nome}?`)) return;
    setSalvando(usuario._id); setMensagem(''); setErro(false);
    try {
      const { data } = await axios.put(`${API_CONFIG.API_URL}/acessos/${usuario._id}`, { menus: restaurar ? null : usuario.selecionados }, { headers: headers() });
      setUsuarios(lista => lista.map(u => u._id === usuario._id ? { ...u, selecionados: data.menus, menus_efetivos: data.menus, personalizado: data.personalizado } : u));
      setMensagem(`Acessos de ${usuario.nome} atualizados.`);
      onAtualizar?.();
    } catch (err) { setErro(true); setMensagem(err.response?.data?.message || 'Não foi possível salvar os acessos.'); }
    finally { setSalvando(null); }
  };
  const alterarDesktop = async (usuario) => {
    const habilitado = usuario.acesso_desktop !== true;
    if (!window.confirm(`${habilitado ? 'Liberar' : 'Bloquear'} Acesso Vetim desktop de ${usuario.nome}? O acesso pelo site continuará funcionando normalmente.`)) return;
    setSalvando(usuario._id); setErro(false); setMensagem('');
    try {
      const { data } = await axios.put(`${API_CONFIG.API_URL}/acessos/${usuario._id}/desktop`, { habilitado }, { headers: headers() });
      setUsuarios(lista => lista.map(u => u._id === usuario._id ? { ...u, acesso_desktop: data.acesso_desktop } : u));
      setMensagem(`Permissão de acesso desktop de ${usuario.nome} atualizada.`);
      onAtualizar?.();
    } catch (err) { setErro(true); setMensagem(err.response?.data?.message || 'Não foi possível alterar o acesso desktop.'); }
    finally { setSalvando(null); }
  };
  const filtrados = usuarios.filter(u => (!usuarioId || u._id === usuarioId) && `${u.nome} ${u.usuario}`.toLowerCase().includes(busca.toLowerCase()));
  return <section className="content-section acessos-page">
    {!embedded && <header className="acessos-header">
      <div className="page-header-mobile">
        <button className="mobile-menu-toggle" aria-label="Abrir menu lateral" onClick={onToggleSidebar}>☰</button>
        <div><span className="acessos-eyebrow">GESTÃO DA LOJA</span><h1>Acessos por usuário</h1></div>
      </div>
      <span className="acessos-badge acessos-badge--blue">Exclusivo para analistas</span>
    </header>}
    <p className="acessos-description">Defina quais menus cada pessoa pode acessar. As permissões de ações do cargo continuam valendo.</p>
    <aside className="acessos-notice">
      <span className="acessos-notice-icon" aria-hidden="true">i</span>
      <div><strong>Você tem o controle dos acessos</strong><p>Desmarcar todos bloqueia os menus operacionais. Analistas mantêm acesso a esta gestão. As alterações valem imediatamente no servidor e atualizam o menu em até 30 segundos.</p></div>
    </aside>
    {!usuarioId && <div className="acessos-toolbar">
      <label className="acessos-search"><svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 4.5 4.5" /></svg>
        <input aria-label="Buscar usuário" placeholder="Buscar por nome ou usuário…" value={busca} onChange={e => setBusca(e.target.value)} />
      </label>
      <span className="acessos-count">{carregando ? 'Carregando usuários…' : `${filtrados.length} de ${usuarios.length} usuários`}</span>
    </div>}
    {mensagem && <p className={`acessos-feedback ${erro ? 'acessos-feedback--error' : ''}`} role={erro ? 'alert' : 'status'}>{mensagem}</p>}
    {carregando ? <div className="acessos-empty" role="status"><span className="acessos-spinner" aria-hidden="true" />Carregando acessos…</div> : !filtrados.length ? <div className="acessos-empty"><strong>{busca ? 'Nenhum usuário encontrado' : 'Nenhum usuário disponível'}</strong><span>{busca ? 'Tente buscar por outro nome ou usuário.' : 'Os usuários da sua loja aparecerão aqui.'}</span></div> : filtrados.map(u => {
      const alterado = u.selecionados.length !== u.menus_efetivos.length || u.selecionados.some(id => !u.menus_efetivos.includes(id));
      const isAnalista = u.tipo === 'analista' || String(u.cargo || '').toLowerCase().includes('analista');
      return <article key={u._id} className={`acessos-card ${alterado ? 'acessos-card--changed' : ''}`} aria-busy={salvando === u._id}>
        <div className="acessos-card-header">
          <div className="acessos-identity"><span className="acessos-avatar" aria-hidden="true">{(u.nome || '?').trim().charAt(0).toUpperCase()}</span><div><h2>{u.nome}</h2><p>{u.usuario} <span aria-hidden="true">·</span> {u.cargo}</p></div></div>
          <div className="acessos-badges"><span className={`acessos-badge ${u.status === 'ativo' ? 'acessos-badge--active' : ''}`}>{u.status}</span><span className={`acessos-badge ${u.personalizado ? 'acessos-badge--blue' : ''}`}>{u.personalizado ? 'Personalizado' : 'Padrão do cargo'}</span></div>
        </div>
        <fieldset disabled={salvando !== null} className="acessos-fieldset">
          <div style={{ marginBottom: 16 }}>
            <label className={`acessos-menu-option ${u.acesso_desktop === true || isAnalista ? 'acessos-menu-option--selected' : ''}`}>
              <input type="checkbox" checked={u.acesso_desktop === true || isAnalista} disabled={isAnalista || salvando !== null} onChange={() => alterarDesktop(u)} />
              <span>Acesso Vetim desktop</span>
            </label>
            <p style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>
              {isAnalista ? 'Analistas possuem acesso irrestrito ao aplicativo desktop e API.' : 'Autoriza login e acesso por aplicativo desktop/API. Bloqueado por padrão para outros cargos.'}
            </p>
          </div>
          <legend>Menus permitidos <span>{u.selecionados.length} de {catalogo.length} selecionados</span></legend>
          <div className="acessos-menu-grid">
          {catalogo.map(menu => <label key={menu.id} className={`acessos-menu-option ${u.selecionados.includes(menu.id) ? 'acessos-menu-option--selected' : ''}`}>
            <input type="checkbox" checked={u.selecionados.includes(menu.id)} onChange={e => {
              const marcado = e.target.checked;
              setUsuarios(lista => lista.map(item => item._id === u._id ? { ...item, selecionados: marcado ? [...item.selecionados, menu.id] : item.selecionados.filter(id => id !== menu.id) } : item));
            }} /><span>{menu.label}</span>
          </label>)}
          </div>
        </fieldset>
        <div className="acessos-card-footer">
          <span className={`acessos-save-hint ${alterado ? 'acessos-save-hint--pending' : ''}`}>{alterado ? 'Alterações não salvas' : 'Selecione os menus e salve para aplicar.'}</span>
          <div className="acessos-actions">
            <button className="acessos-button acessos-button--secondary" disabled={salvando !== null} onClick={() => salvar(u, true)}>Restaurar padrão</button>
            <button className="acessos-button acessos-button--primary" disabled={salvando !== null} onClick={() => salvar(u)}>{salvando === u._id ? 'Salvando…' : 'Salvar acessos'}</button>
          </div>
        </div>
      </article>;
    })}
  </section>;
}
